import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Question } from '../interfaces/question';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {
  QDataSubject = new Subject();
  QSave = new Subject();

  constructor(
    private http: HttpClient
  ) { }

  getAllQuestions(companyId: string, category: string): Observable<any> {
    return this.http.get(`${environment.url}/bucket/${environment.buckets.wizard_questions}/data?filter={"company":"${companyId}", "category": "${category}"}&relation=true`)
    // return this.http.get(`${environment.url}/bucket/${environment.buckets.wizard_questions}/data`)
  }

  saveQuestion(qt: Question): Observable<any> {
    if (qt._id) {
      const flated = this.flatQuestion(qt);
      return this.updateQuestion(flated);
    } else {
      console.log('COM_KEY', qt.company);
      return this.addQuestion(qt);
    }
  }

  public updateQuestion(qt: any): Observable<any> {
    // return this.http.put(`${environment.url}/bucket/${environment.buckets.wizard_questions}/data/${qt._id}`, this.flatQuestion(qt));
    return this.http.put(`${environment.url}/bucket/${environment.buckets.wizard_questions}/data/${qt._id}`, qt);
  }

  private addQuestion(qt): Observable<any> {
    return this.http.post(`${environment.url}/bucket/${environment.buckets.wizard_questions}/data/`, qt);
  }

  deleteQuestion(id: string) { //FUNKTIONIERT
    return this.http.delete(`${environment.url}/bucket/${environment.buckets.wizard_questions}/data/${id}`);
  }

  getQuestionById(id: string) {
    return this.http.get(`${environment.url}/bucket/${environment.buckets.wizard_questions}/data/${id}`)
  }

  // TODO: Flaten von Objekt
  flatQuestion(qt) {
    if (typeof qt.company !== "string")
      qt.company = qt.company._id;//flaten funktioniert
    console.log('flatQuestion:', qt.company);

    if (typeof qt.category !== "string")
      qt.category = qt.category._id
    return qt;
  }
}
